<div class="max-z-index " fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1rem">
  <div fxFlex="none" class="pl-20 mnb-4">
      <mat-icon *ngIf="data.snackbarType == SnackbarType.Success">check_circle</mat-icon>
      <mat-icon *ngIf="data.snackbarType == SnackbarType.Error">error</mat-icon>
  </div>
  <div fxFlex>
      <span>{{data.message | translate}}</span>
  </div>
  <div fxFlex="none" class="pr-12">
      <mat-icon class="pull-right cursor-pointer" [class.close-grey]="data.snackbarType == SnackbarType.Success"
          (click)="dismiss()">close
      </mat-icon>
  </div>
</div>
